var inherit = require("../../general.js").inherit;
var ObservableCachedFunction = require("./../observableCachedFunction.js");

var ObservableTreeCachedFunction = function(treeNode, name, getter, sensitivityList, size){
    ObservableCachedFunction.call(this, getter, sensitivityList, treeNode, size);
    this._treeNode = treeNode;
    this._name = name;
};
inherit(ObservableTreeCachedFunction, ObservableCachedFunction);
ObservableTreeCachedFunction.createNewFunction = ObservableCachedFunction.createNewFunction;
ObservableTreeCachedFunction.prototype.getName = function(){ return this._name; };
ObservableTreeCachedFunction.prototype.getTreeNode = function(){ return this._treeNode; };

ObservableTreeCachedFunction.prototype.setDirty = function(trigger){
    ObservableCachedFunction.prototype.setDirty.call(this);

    var triggerNode = trigger._treeNode || trigger; // node who triggered this setDirty
    if (!triggerNode._triggeredShadows) triggerNode._triggeredShadows = [];
    triggerNode._triggeredShadows.push(this);

};

module.exports = ObservableTreeCachedFunction;